export const VoohCreationDropZoneOptions = {
  sizes: [{ name: 'Main', width: 1920, height: 1080 }],
  icon: 'dg-cl',
  acceptedFormats: ['jpeg', 'jpg', 'png', 'zip'],
  maxMovieLength: '10',
}
